import { DIMENSIONS, EXPERTS, JOB } from '../../content'
import { anim, stagger } from '../../motion'
import { BeamBands, COLORS } from '../../primitives'
import { Line, Words } from '../kit'

// Drei Expert:innen setzen Punkte, daraus wachsen Ideal- und Übergangsbereich
export default function CinProfile() {
  return (
    <div className='cin-pad'>
      <div className='cin-head'>
        <Line at={[0, 0.08]} className='cin-eyebrow'>
          Die Stelle · {JOB}
        </Line>
        <h2 className='cin-title'>
          <Words text='Erst die Frage. Dann die Auswahl.' at={[0.02, 0.2]} />
        </h2>
      </div>

      <div className='cin-profile'>
        <div
          className='cin-profile__legend'
          style={anim({ at: [0.14, 0.22], y: 16 })}
        >
          {EXPERTS.map((e) => (
            <span key={e.initials} className='cin-legend-item'>
              <i style={{ background: COLORS[e.color] }} />
              {e.role}
            </span>
          ))}
          <span className='cin-legend-item'>
            <i
              className='cin-swatch'
              style={{ background: 'rgb(167 247 231)' }}
            />
            Idealbereich
          </span>
          <span className='cin-legend-item'>
            <i
              className='cin-swatch'
              style={{ background: 'rgb(253 218 148)' }}
            />
            Übergangsbereich
          </span>
        </div>

        {DIMENSIONS.map((d, row) => (
          <div key={d.name} className='cin-profile__row'>
            <div
              className='cin-profile__label'
              style={anim({ at: stagger(0.1, 0.02, 0.08, row), x: -30, y: 0 })}
            >
              {d.name}
            </div>
            <div className='cin-profile__track'>
              <BeamBands
                ideal={d.ideal}
                trans={d.trans}
                at={stagger(0.56, 0.03, 0.12, row)}
              />
              {d.experts.map((v, e) => (
                <div
                  key={e}
                  className='cin-profile__pin'
                  style={{ left: `${v}%` }}
                >
                  <div
                    className='cin-profile__dot'
                    style={{
                      background: COLORS[EXPERTS[e].color],
                      ...anim({
                        at: stagger(0.22 + e * 0.08, 0.02, 0.08, row),
                        y: -320,
                        s: 0.4
                      })
                    }}
                  />
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>

      <div className='cin-chips' style={anim({ at: [0.74, 0.84], y: 24 })}>
        <span className='cin-chip'>3 Expert:innen</span>
        <span className='cin-chip'>5 bis 10 Minuten pro Person</span>
        <span className='cin-chip cin-chip--blue'>
          Anforderungsprofil nach DIN 33430
        </span>
      </div>
    </div>
  )
}
